import { ProductKey } from "@/components/signup/utils";

// Redirection for product to supported Bundle
export const handleSignupRouteRedirects = ({
    product,
    bundle,
    isUpgradeEligible,
    edition
}: {
    product: string;
    bundle: string;
    isUpgradeEligible?: boolean;
    edition?: string;
}): boolean => {
    const townsquareRedirectionURL =
        "https://community.atlassian.com/t5/Atlas-Group-articles/Atlas-is-evolving/ba-p/2686154";
    const productParamRedirect = (): boolean => {
        const productBundleMap: { [key: string]: string } = {
            "loom": "loom",
            "com.atlassian.bitbucket": "bitbucket",
            "opsgenie": "opsgenie",
            "compass": "compass",
            "statuspage": "statuspage"
        };
        const bundleKey = productBundleMap[product];

        if (bundleKey && bundle !== bundleKey) {
            if (typeof window.location.assign === "function") {
                const currentUrl = new URL(window.location.href);
                currentUrl.searchParams.set("bundle", bundleKey);
                currentUrl.searchParams.delete("product");
                window.location.assign(currentUrl.toString());
            }
            return true;
        }
        if (product === "atlassian-whiteboard") {
            if (typeof window.location.assign === "function") {
                const currentUrl = new URL(window.location.href);
                currentUrl.searchParams.set("product", "confluence.ondemand");
                window.location.assign(currentUrl.toString());
            }
            return true;
        }
        if (product === "townsquare") {
            if (typeof window.location.assign === "function") {
                window.location.assign(townsquareRedirectionURL);
            }
            return true;
        }
        return false;
    };
    if (product && productParamRedirect()) {
        return true;
    }
    const bundleParamRedirect = (): boolean => {
        const isJswRedirectBundle =
            bundle === "avocado" ||
            bundle === "jira-ops" ||
            bundle === "devops";
        const isBitbucketRedirectBundle =
            bundle === "jira-software-bitbucket" ||
            bundle === "bitbucket-jira-software";

        if (isJswRedirectBundle || isBitbucketRedirectBundle) {
            const redirectBundle = isJswRedirectBundle
                ? "jira-software"
                : "bitbucket";
            if (typeof window.location.assign === "function") {
                const currentUrl = new URL(window.location.href);
                currentUrl.searchParams.set("bundle", redirectBundle);
                window.location.assign(currentUrl.toString());
            }
            return true;
        }
        const isTeamCentralBundle =
            bundle === "team-central" || bundle === "atlas";
        if (isTeamCentralBundle) {
            if (typeof window.location.assign === "function") {
                window.location.assign(townsquareRedirectionURL);
            }
            return true;
        }
        return false;
    };
    if (bundle && bundleParamRedirect()) {
        return true;
    }
    const collectionRedirection = (): boolean => {
        if (
            (product === ProductKey.JIRA_SERVICE_MANAGEMENT ||
                bundle === "jira-service-management" ||
                bundle === "jira-service-desk") &&
            (edition === "free" || isUpgradeEligible === false)
        ) {
            if (typeof window.location.assign === "function") {
                const currentUrl = new URL(window.location.href);
                currentUrl.searchParams.set("bundle", "service-collection");
                currentUrl.searchParams.set(
                    "primaryCollectionProduct",
                    ProductKey.JIRA_SERVICE_MANAGEMENT
                );
                currentUrl.searchParams.delete("product");
                window.location.assign(currentUrl.toString());
            }
            return true;
        }
        return false;
    };
    if (collectionRedirection()) {
        return true;
    }
    const serviceCollectionBundleRedirection = (): boolean => {
        const bundlesToRedirect = [
            "jira-service-desk-jira-software-confluence",
            "confluence-jira-service-desk",
            "jira-software-jira-service-management"
        ];
        if (bundlesToRedirect.includes(bundle)) {
            if (typeof window.location.assign === "function") {
                const currentUrl = new URL(window.location.href);
                currentUrl.searchParams.set("bundle", "service-collection");
                currentUrl.searchParams.set(
                    "primaryCollectionProduct",
                    ProductKey.JIRA_SERVICE_MANAGEMENT
                );
                window.location.assign(currentUrl.toString());
            }
            return true;
        }
        return false;
    };
    if (serviceCollectionBundleRedirection()) {
        return true;
    }

    return false;
};
